import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n,
} from "@/composables/useI18n";

import {
  computed,
  PropType,
  ref, unref,
  watch,
} from "vue";

import VueI18n from "vue-i18n";

import {
  isStringAndHasValue,
  startDateBeforeEndDate,
} from "@/scripts/Common/validators/defaultValidator";

import {
  DateFormats,
} from "@/scripts/Common/DateFormats";

import {
  isValidDate,
} from "@/scripts/Validations/Validations";

import {
  formatDate,
} from "@/scripts/Common/helpers/dateHelpers";

import {
  useDateStringLocalization,
} from "@/composables/formatDateStringWithLocalization";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractEdit',
  props: {
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  label: {
    required: false,
    type: String as PropType<string | VueI18n.TranslateResult>,
    default: ''
  },
  contractStart: {
    required: false,
    type: String as PropType<string>,
    default: ''
  },
  contractEnd: {
    required: false,
    type: String as PropType<string>,
    default: ''
  },
  expanded: {
    required: false,
    type: Array as PropType<number[]>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'onValidChange',
  'update:contractStart',
  'update:contractEnd'
],
  setup(__props, { emit: emits }) {

const props = __props;


const {
  t,
} = useI18n();

const {
  formatDateBasedOnLocalization
} =  useDateStringLocalization();





const valid = ref(true);
const contractForm = ref();

const internalExpand = ref(props.expanded);

const contractStart = computed({
  get() {
    return formatDate(props.contractStart, DateFormats.ISO8601_LONG)
  },
  set(value: string | undefined) {
    emits('update:contractStart', isStringAndHasValue(value) ? value : undefined);
  }
})

const contractEnd = computed({
  get() {
    return formatDate(props.contractEnd, DateFormats.ISO8601_LONG)
  },
  set(value: string | undefined) {
    emits('update:contractEnd', isStringAndHasValue(value) ? value : undefined);
  }
})

const validate = () => contractForm.value.validate();

watch(valid, () => {
  validate();
  emits('onValidChange', unref(valid))
})

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded
})

return { __sfc: true,t, formatDateBasedOnLocalization, props, emits, valid, contractForm, internalExpand, contractStart, contractEnd, validate, startDateBeforeEndDate, isValidDate }
}

})